import React, { useState, useEffect } from 'react'
import { Accordion, Checkbox, Header, Icon, Form } from 'semantic-ui-react'
import { Button } from 'semantic-ui-react'
import { useJobSearch } from '@src/state/jobSearch'
import { useMediaQuery } from 'react-responsive'

import config from './filters.json'
import styles from './style.module.css'
import SalarySlider from '@components/SalarySlider'
import DatePostedFilter from '@components/FilterBar/DatePostedFilter'

const policies = ['100% Remote', 'Hybrid Remote', 'Onsite']
const roleTypes = ['Full Time', 'Part Time', 'Contract']
const experienceLevels = ['Intern', 'Junior', 'Midlevel', 'Senior', 'Executive']
const filters = [policies, roleTypes, experienceLevels]
const headings = ['Remote Policies', 'Role Types', 'Experience Level']

const values = [
  {
    label: 'Remote-First',
    value: 'remoteFirst',
  },
  {
    label: 'Mission-Driven',
    value: 'missionDriven',
  },
  {
    label: 'Flexible Hours',
    value: 'flexibleHours',
  },
]

const options = [
  { value: 'DAILY', label: 'Daily' },
  { value: 'WEEKLY', label: 'Weekly' },
]

export default function MobileFilter() {
  const [toggle, setToggle] = useState({})
  const [activeIndex, setActiveIndex] = useState(-1)
  const [invisible, setInvisible] = useState(true)
  const [show, setShow] = useState(false)
  const { state, dispatch } = useJobSearch()
  const [salary, setSalary] = useState(state?.salaryMin)
  const [loading, setLoading] = useState(false)
  const { filterStates, filter } = state

  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 820px)' })

  useEffect(() => {
    setSalary(state.salaryMin)
  }, [state])

  useEffect(() => {
    setToggle(filterStates)
  }, [filter, filterStates])

  useEffect(() => {
    if (state?.filter) {
      setInvisible(false)
      setTimeout(() => {
        setShow(true)
      }, 100)
    } else {
      setShow(false)
      setTimeout(() => {
        setInvisible(true)
      }, 300)
    }
  }, [state?.filter])

  const isChecked = (val) => {
    return toggle[val]
    // return state?.filterStates[val]
  }

  const openMobileAlert = () => {
    dispatch({ type: 'setMobileAlert', payload: true })
  }

  const getKeyByValue = (object, value) => {
    return Object.keys(object).find((key) => object[key] === value)
  }

  const handleChange = (key) => {
    setToggle({
      ...toggle,
      [getKeyByValue(config, key)]: !toggle[getKeyByValue(config, key)],
    })
  }

  const handleClick = () => {
    dispatch({ type: 'setFilterStates', payload: toggle })
    dispatch({ type: 'setFilter', payload: false })

    // set salaryMin here
  }

  const handleClose = () => {
    dispatch({ type: 'setFilter', payload: false })
  }

  let filterStyle
  let maskStyle
  let buttonStyle

  if (isTabletOrMobile && show) {
    filterStyle = {
      height: '81vh',
    }
    maskStyle = {
      height: '100vh',
    }
    buttonStyle = {
      bottom: 0,
    }
  } else if (invisible) {
    filterStyle = {
      display: 'none',
    }
    maskStyle = {
      display: 'none',
    }
  } else {
    filterStyle = { height: 0, padding: 0 }
    maskStyle = { height: 0 }
  }

  const handleSalaryChange = (val) =>
    dispatch({ type: 'setSalaryMin', payload: val })

  const handleValuesChange = (val) => {
    console.log('handle change (val): ', val)
    setToggle({
      ...toggle,
      [val]: toggle[val] ? false : true,
    })
  }

  const handleAccordion = (e, titleProps) => {
    const { index } = titleProps
    const newIndex = activeIndex === index ? -1 : index
    setActiveIndex(newIndex)
  }

  return (
    <>
      <div className={styles.mask} style={maskStyle} onClick={handleClose} />
      <div className={styles.container} style={filterStyle}>
        <div className={styles.header}>
          <Header as="h2">Advanced Search</Header>
          <Icon
            name="angle down"
            size="large"
            className={styles.close}
            onClick={handleClose}
          />
        </div>
        <div className={styles.filtersContainer}>
          <div className={styles.filtersWrapper}>
            {filters.map((item, idx) => {
              return (
                <div className={styles.section} key={idx}>
                  <Accordion styled exclusive={false}>
                    <Accordion.Title
                      // active={activeIndex === idx}
                      index={idx}
                      onClick={handleAccordion}
                    >
                      <Header as="h3">
                        {headings[idx]}{' '}
                        <Icon name="dropdown" className={styles.headerIcon} />
                      </Header>
                    </Accordion.Title>
                    <Accordion.Content active={activeIndex === idx}>
                      {item.map((type) => {
                        return (
                          <div
                            className={styles.wrapper}
                            key={type}
                            id={
                              toggle[getKeyByValue(config, type)] &&
                              styles[getKeyByValue(config, type)]
                            }
                          >
                            <Checkbox
                              toggle
                              label={type}
                              className={styles.checkbox}
                              name={getKeyByValue(config, type)}
                              onChange={() => handleChange(type)}
                              // value={toggle[getKeyByValue(config, type)]}
                              checked={toggle[getKeyByValue(config, type)]}
                            />
                          </div>
                        )
                      })}
                    </Accordion.Content>
                  </Accordion>
                </div>
              )
            })}
            <div className={styles.section} key={3}>
              <Accordion styled exclusive={false}>
                <Accordion.Title
                  active={activeIndex === 3}
                  index={3}
                  onClick={handleAccordion}
                >
                  <Header as="h3">
                    {'Salary '}
                    <Icon name="dropdown" className={styles.headerIcon} />
                  </Header>
                </Accordion.Title>
                <Accordion.Content active={activeIndex === 3}>
                  <SalarySlider value={salary} onChange={handleSalaryChange} />
                </Accordion.Content>
              </Accordion>
            </div>
            <div className={styles.section} key={4}>
              <Accordion styled exclusive={false}>
                <Accordion.Title
                  active={activeIndex === 4}
                  index={4}
                  onClick={handleAccordion}
                >
                  <Header as="h3">
                    {'Company Values '}
                    <Icon name="dropdown" className={styles.headerIcon} />
                  </Header>
                </Accordion.Title>
                <Accordion.Content active={activeIndex === 4}>
                  {values.map((item, idx) => {
                    return (
                      <div
                        className={styles.wrapper}
                        key={item.value}
                        id={
                          toggle[getKeyByValue(config, item.value)] &&
                          styles[getKeyByValue(config, item.value)]
                        }
                      >
                        <Checkbox
                          toggle
                          label={item.label}
                          className={styles.checkbox}
                          name={getKeyByValue(config, item.value)}
                          onChange={() => handleValuesChange(item.value)}
                          checked={isChecked(item.value)}
                        />
                      </div>
                    )
                  })}
                </Accordion.Content>
              </Accordion>
            </div>
            <div className={styles.section} key={5}>
              <Accordion styled>
                <Accordion.Title
                  active={activeIndex === 5}
                  index={5}
                  onClick={handleAccordion}
                >
                  <Header as="h3">
                    {'Date Posted '}
                    <Icon name="dropdown" className={styles.headerIcon} />
                  </Header>
                </Accordion.Title>
                <Accordion.Content active={activeIndex === 5}>
                  <DatePostedFilter mobile />
                </Accordion.Content>
              </Accordion>
            </div>
          </div>
        </div>
        <div className={styles.buttonWrapper} style={buttonStyle}>
          <Button
            primary
            fluid
            size="large"
            onClick={handleClick}
            className={styles.updateSearch}
          >
            Update Search
          </Button>
        </div>
      </div>
    </>
  )
}
